"use client";

import React, { useState } from "react";
import AuthForm from "../../components/authForm/AuthForm";
import { Link } from "react-router-dom";
import styles from "./Signup.module.scss";

const Signup = () => {
  const [message, setMessage] = useState("");
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSignup = async (data) => {
    if (!data.email) {
      console.error("Email is required for signup");
      return;
    }

    try {
      const res = await fetch("/api/signup", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const result = await res.json();
      setMessage(result.message);
      if (res.status === 201) {
        setIsSuccessful(true);
        setIsSuccess(true);
      } else {
        setIsSuccess(false);
      }
    } catch (error) {
      setMessage("An error occurred during signup");
      setIsSuccess(false);
    }
  };

  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.box}`}>
        {isSuccessful ? (
          <div className={styles.successMessage}>
            <p>{message || "Signup successful! Check your email for confirmation."}</p>
            <Link to="/login">
              <p className={styles.redirectLink}>Back to login</p>
            </Link>
          </div>
        ) : (
          <>
            <AuthForm mode="Signup" onSubmit={handleSignup} />
            {message && (
              <p className={`${styles.message} ${isSuccess ? styles.success : styles.error}`}>
                {message}
              </p>
            )}
            <Link to="/login">
              <p className={styles.redirectLink}>Already have an account? Log in</p>
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default Signup;
